export type AnalyticsEvent =
  | {
      enabled?: boolean
      eventName?: string
      props?: { key: string; value: string }[]
    }
  | null
  | undefined

/**
 * Build data attributes for the global AutoTrack click handler.
 * - If analytics is disabled or no eventName, returns an empty object
 * - Merges optional default props
 */
export function analyticsAttrs(
  analytics: AnalyticsEvent,
  defaults?: { eventName?: string; props?: Record<string, unknown> }
): Record<string, string> {
  if (!analytics?.enabled && !defaults?.eventName) return {}

  const event = analytics?.eventName || defaults?.eventName
  if (!event) return {}

  const propsFromArray = (analytics?.props || []).reduce<
    Record<string, string>
  >((acc, p) => {
    if (p.key) acc[p.key] = p.value
    return acc
  }, {})

  const props = { ...defaults?.props, ...propsFromArray }

  const attrs: Record<string, string> = {
    "data-analytics-event": event
  }

  if (Object.keys(props).length > 0) {
    try {
      attrs["data-analytics-props"] = JSON.stringify(props)
    } catch {
      // ignore JSON issues; no props if invalid
    }
  }

  return attrs
}

/**
 * Convenience for manual usage without an analytics object.
 */
export function simpleAnalyticsAttrs(
  eventName?: string,
  props?: Record<string, unknown>
): Record<string, string> {
  if (!eventName) return {}
  const attrs: Record<string, string> = { "data-analytics-event": eventName }
  if (props) {
    try {
      attrs["data-analytics-props"] = JSON.stringify(props)
    } catch {
      // ignore
    }
  }
  return attrs
}
